export default "__VITE_ASSET__$AiPyVDP__"